/* global Office */

import { tracer } from "@app-services/tracer.service";
import { LoginDialogData } from "@classes/login-dialog-data.class";
import { LoginDialogService } from "@dialog-services/login-dialog.service";

// TODO URP-665: See if we can remove this dialog.

(function () {
    "use strict";

    Office.onReady(() => {

        try {

            tracer.info("initialized login dialog");

            //Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, onMessageFromParent);

            //Office.context.ui.messageParent("dialog-ready"); 

        } catch (error) {
            
            tracer.error("Error while initializing login dialog", error);

            //Office.context.ui.messageParent("close-dialog-and-send"); 
        }
    });

    function onMessageFromParent(msg: Office.DialogParentMessageReceivedEventArgs) {

        //try {

        //    const dialogData = JSON.parse(msg.message) as LoginDialogData;
    
        //    const loginDialogService = new LoginDialogService(dialogData);
            
        //    loginDialogService.populateInitialStrings();

        //    loginDialogService.handleRedirect();
            
        //} catch (ex) {

        //    Log.cError("An error occurred in login dialog onMessageFromParent", ex);
            
        //    Office.context.ui.messageParent("close-dialog-and-send"); 
        //}
    }
})();
